import axios from '@/utils/axiosReq'
import URL from './urlConstants'
class IndexFetch {
  // 权限校验接口
  getLoggingValidSm () {
    return axios.get(URL.INDEX_URLS.LOGGING_VALID)
  }
  getSellerNoUser () {
    return axios.get(URL.INDEX_URLS.SELLERNO_USER)
  }
  saveApply (params) {
    return axios.post(URL.INDEX_URLS.APPLY_SAVE, params)
  }
}
const indexFetch = new IndexFetch()
export default indexFetch
